import React from "react";
import { endUsers } from "../../data/endUsers";
import Reveal from "./Reveal";

const manufacturerLogos = {
  ford: { src: "/ford2.png", width: 3840, height: 2160 },
  lucid: { src: "/vendor-partner-logos/lucid-logo.png", width: 400, height: 200 },
};

export default function HomeCaseStudies() {
  if (endUsers.length === 0) return null;

  return (
    <section
      id="work"
      className="scroll-mt-24 border-t border-gray-200 bg-white py-12 sm:py-14"
      aria-labelledby="work-heading"
    >
      <div className="px-4 sm:px-6 lg:px-8">
        <Reveal>
          <h2 id="work-heading" className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
            Work from live plants
          </h2>
          <p className="mt-3 max-w-2xl text-base leading-relaxed text-gray-600">
            Automotive and industrial programs.
          </p>
        </Reveal>

        <Reveal className="mt-8" delay={0.04}>
          <div className="grid gap-2 lg:grid-cols-2">
            {endUsers.map((user) => (
              <div
                key={user.slug}
                className="flex items-center gap-5 bg-gray-100 px-5 py-5 sm:gap-6 sm:px-6 sm:py-6"
              >
                <img
                  src={manufacturerLogos[user.slug].src}
                  alt={user.name}
                  width={manufacturerLogos[user.slug].width}
                  height={manufacturerLogos[user.slug].height}
                  className={
                    user.slug === "lucid"
                      ? "h-[3.9rem] w-auto max-w-[182px] shrink-0 object-contain sm:h-[4.55rem] sm:max-w-[208px]"
                      : "h-12 w-auto max-w-[140px] shrink-0 object-contain sm:h-14 sm:max-w-[160px]"
                  }
                />
                <p className="text-sm leading-relaxed text-gray-600 sm:text-base">
                  {user.descriptor}
                </p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
